import { lazy, Suspense } from 'react';

import { GOOGLE_MAPS_API_KEY } from '../../helpers/globals';

const GoogleMapDisplay = lazy(
  () => import('@opendoor/cinderblocks/growth/GoogleMapDisplay/GoogleMapDisplay'),
);
const GoogleMapDisplayWrapper = (props) => (
  <Suspense fallback={null}>
    <GoogleMapDisplay googleMapsApiKey={GOOGLE_MAPS_API_KEY} showLoader={false} {...props} />
  </Suspense>
);

export default GoogleMapDisplayWrapper;
